import { ScreenFrame } from '@/components/Screen';
import { ShortcutGrid } from '@/components/DataList';
import type { SessionUser } from '@/auth/session';
import { customerSideNavGroups, type CustomerScreenKey } from '@/nav/keys';

export function MoreScreen({
  user,
  onNavigate,
}: {
  user: SessionUser;
  onNavigate: (key: CustomerScreenKey) => void;
}) {
  const apiEnabled = Number(user.api_enabled ?? 0) === 1;
  const groups = customerSideNavGroups({
    role: user.role,
    apiEnabled,
  });

  const items = groups
    .flatMap((g) => g.items)
    .filter((item) => !['home', 'bills', 'products', 'wallet', 'orders'].includes(item.key))
    .map((item) => ({
      key: item.key,
      title: item.label,
      text: item.label,
      onClick: () => onNavigate(item.key),
    }));

  return (
    <ScreenFrame mode="customer" title="المزيد" subtitle="إعدادات الحساب والأدوات الإضافية">
      <ShortcutGrid items={items} />
    </ScreenFrame>
  );
}
